import { gql } from '@apollo/client'
import React from 'react'

import { formsClient, serviceOrdersClient } from '../../../../../utils/apollo/api'
import { useQuery } from '../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useRepliesState = () => React.useContext(Context) || {}
export const useReplies = () => useRepliesState()?.replies || []

const QUERY = gql`
  query Replies($filter: ReplyFilter, $sort: [ReplySort]) {
    replies(limit: 100, sort: $sort, filter: $filter, recursive: true) {
      id
      value
      notes
      serviceOrderId
      questionId
      documents {
        id
        src
        type
      }
      question {
        id
        name
        typeName
        type {
          id
          name
        }
      }
    }
  }
`

const RelatedRepliesLoader = ({ children, reply }) => {
  const isFromSO = !!reply.serviceOrderId
  const client = isFromSO ? serviceOrdersClient : formsClient
  const filter = isFromSO ? { serviceOrderIds: reply.serviceOrderId } : { formReplyIds: reply.formReplyId }

  const { data, fetchMore, ...state } = useQuery(QUERY, {
    variables: {
      sort: [{ field: 'QUESTION_ORDINATION', type: 'ASC' }],
      filter: { ...filter, parentReferences: reply.question.reference }
    },
    client
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} empty={false}>
        {children}
      </StatePresenter>
    </Provider>
  )
}

export default RelatedRepliesLoader
